export enum SpecialEventSeason {
  WINTER = "WINTER",
  SPRING = "SPRING",
  SUMMER = "SUMMER",
  AUTUMN = "AUTUMN",
}

export enum SpecialEventState {
  ONGOING = "ONGOING",
  FINISHED = "FINISHED",
}

export enum SpecialEventTextColor {
  DARK = "dark",
  LIGHT = "light",
}

export const CURRENT_SPECIAL_EVENT_SEASON = SpecialEventSeason.SPRING

export enum SpecialEventAvatarBorder {
  WINTER = "border-secondary-blue-400",
  SPRING = "border-secondary-pink-100",
  AUTUMN = "border-[#0C180F]",
}

export const SpecialEventBackground: Record<SpecialEventSeason, string> = {
  [SpecialEventSeason.WINTER]: "bg-[url('/bg-hiver2025.png')] bg-contain opacity-30",
  [SpecialEventSeason.SPRING]: "bg-[url('/season-spring.png')] bg-[length:100%_auto] opacity-40",
  [SpecialEventSeason.SUMMER]: "bg-[url('/season-summer.png')] bg-contain bg-no-repeat opacity-50",
  [SpecialEventSeason.AUTUMN]: "",
}

export const SpecialEventBannersBackground: Record<SpecialEventSeason, string> = {
  [SpecialEventSeason.WINTER]: "linear-gradient(90deg, #02285A 25%, #3A69A6 50%, #02285A 75%)",
  [SpecialEventSeason.SPRING]: "linear-gradient(90deg, #FFCDE1 15%, #EED7E0 50%, #FFCDE1 85%)",
  [SpecialEventSeason.SUMMER]: "linear-gradient(90deg, #FFFFFF 15%, #EFEFEF 50%, #FFFFFF 85%)",
  [SpecialEventSeason.AUTUMN]: "linear-gradient(90deg, #0C180F 25%, #00371D 50%, #0C180F 75%)",
}

export const backgroundStyleVariants: Record<SpecialEventSeason, SpecialEventTextColor> = {
  [SpecialEventSeason.SPRING]: SpecialEventTextColor.DARK,
  [SpecialEventSeason.WINTER]: SpecialEventTextColor.LIGHT,
  [SpecialEventSeason.SUMMER]: SpecialEventTextColor.DARK,
  [SpecialEventSeason.AUTUMN]: SpecialEventTextColor.LIGHT,
}

export const avatarBorderStyleVariants: Record<SpecialEventSeason, SpecialEventAvatarBorder> = {
  [SpecialEventSeason.SPRING]: SpecialEventAvatarBorder.SPRING,
  [SpecialEventSeason.WINTER]: SpecialEventAvatarBorder.WINTER,
  [SpecialEventSeason.SUMMER]: SpecialEventAvatarBorder.SPRING,
  [SpecialEventSeason.AUTUMN]: SpecialEventAvatarBorder.AUTUMN,
}

export const bannerBackgroundStyleVariants: Record<SpecialEventSeason, SpecialEventTextColor> = {
  [SpecialEventSeason.WINTER]: SpecialEventTextColor.LIGHT,
  [SpecialEventSeason.SPRING]: SpecialEventTextColor.DARK,
  [SpecialEventSeason.SUMMER]: SpecialEventTextColor.DARK,
  [SpecialEventSeason.AUTUMN]: SpecialEventTextColor.LIGHT,
}

export type SpecialEventUserParticipation = {
  rank: number
  score: number
  timer: number
  goodAnswerAmount: number
  wrongAnswerAmount: number
}

export type SpecialEvent = {
  id: number
  daysLeft: number
  maxScore: number
  name: string
  headline: string
  description: string
  color: string
  url: string
  state: SpecialEventState
  userParticipation?: SpecialEventUserParticipation
  topParticipants: SpecialEventParticipant[]
  totalParticipants: number
}

export type SpecialEventParticipant = {
  id: number
  rank: number
  firstName: string
  lastName: string
  avatar: string
  score: number
  timeSpentInSeconds: number
}
